import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.222 7.333c-1.839 0-4.11.106-6.818.318a3.889 3.889 0 0 0-3.576 3.602 70.61 70.61 0 0 0-.161 4.97c0 1.797.053 3.453.16 4.969a3.889 3.889 0 0 0 3.577 3.602c2.704.211 4.976.317 6.818.317 1.842 0 4.114-.106 6.818-.317a3.889 3.889 0 0 0 3.576-3.602c.031-.434.058-.878.08-1.335l3.225 1.613a1.667 1.667 0 0 0 2.412-1.49v-7.516a1.667 1.667 0 0 0-2.412-1.49l-3.226 1.613a52.203 52.203 0 0 0-.079-1.334A3.889 3.889 0 0 0 20.04 7.65c-2.707-.212-4.98-.318-6.818-.318Z",
    fill: "currentColor"
  }));
};

var SvgVideo = styled(SvgComponent).withConfig({
  displayName: "Video__SvgVideo",
  componentId: "sc-14x4pwr-0"
})(["", " ", ""], size, color);
export default SvgVideo;